import React, { useState } from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme
} from "@mui/material";
import {
  Search as SearchIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CleaningServices as CleaningIcon,
} from "@mui/icons-material";

const mockServices = [
  {
    id: 1,
    name: "Standard Cleaning",
    description: "Basic cleaning service for regular maintenance",
    duration: "2-3 hours",
    price: 89,
    category: "Residential",
    status: "Active",
    cleaners: 45
  },
  {
    id: 2,
    name: "Deep Cleaning",
    description: "Thorough cleaning for move-in/move-out",
    duration: "4-6 hours",
    price: 189,
    category: "Residential",
    status: "Active",
    cleaners: 32
  },
  {
    id: 3,
    name: "Office Cleaning",
    description: "Commercial cleaning for offices",
    duration: "3-4 hours",
    price: 149,
    category: "Commercial",
    status: "Active",
    cleaners: 28
  }
];

export default function Services() {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const filteredServices = mockServices.filter(service =>
    service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    service.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const stats = [
    { label: 'Total Services', value: '12', change: '+2' },
    { label: 'Active Services', value: '10', change: '+1' },
    { label: 'Categories', value: '3', change: '0' },
    { label: 'Avg. Price', value: '$125', change: '+5%' },
  ];

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h4" fontWeight="bold">
            Service Management
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenDialog(true)}
          >
            Add Service
          </Button>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Manage cleaning services, pricing, and availability
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent>
                <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {stat.label}
                </Typography>
                <Chip 
                  label={stat.change} 
                  size="small" 
                  color="success"
                  variant="outlined"
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <TextField
              placeholder="Search services..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ minWidth: 300 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <TableContainer>
          <Table>
            <TableHead sx={{ bgcolor: theme.palette.grey[50] }}>
              <TableRow>
                <TableCell>Service Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Cleaners</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredServices.map((service) => (
                <TableRow key={service.id} hover>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CleaningIcon color="primary" />
                      <Typography fontWeight="600">{service.name}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {service.description}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip label={service.category} size="small" variant="outlined" />
                  </TableCell>
                  <TableCell>
                    <Typography>{service.duration}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight="600" color="primary">
                      ${service.price}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>{service.cleaners}</Typography>
                  </TableCell>
                  <TableCell>
                    <Switch checked={service.status === 'Active'} color="success" />
                  </TableCell>
                  <TableCell>
                    <IconButton size="small">
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}